import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Construction: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m337.46 549.28-29.32-37.21c-5.25-6.81-8.14-15.39-8.14-24.17v-127.91h180v127.91c0 8.78-2.89 17.36-8.14 24.17l-28.61 37.08-23.75-18.32 28.61-37.08c1.22-1.59 1.9-3.66 1.9-5.85v-97.91h-120v97.91c0 2.16.66 4.22 1.86 5.8l29.16 37.01-23.56 18.57z' />
    <path d='m375 180h30v190h-30z' />
    <path d='m480 150h-180v-30h150c16.57 0 30 13.43 30 30z' />
    <path d='m660 660h-30c0-53.08-20.19-80-60-80-33.08 0-60 22.43-60 50h-30c0-44.11 40.37-80 90-80 26.47 0 48.66 9.05 64.16 26.19 17.15 18.95 25.84 47.15 25.84 83.81z' />
    <path d='m150 660h-30c0-30.65 9.04-56.28 26.14-74.13 15.98-16.68 38.67-25.87 63.86-25.87 48.79 0 90 30.22 90 66h-30c0-7.55-5.82-16.14-15.57-22.96-11.84-8.29-28.03-13.04-44.43-13.04s-31.78 5.75-42.2 16.63c-11.64 12.15-17.8 30.61-17.8 53.37z' />
    <path d='m510 630h-30c0-46.87-40.37-85-90-85s-90 38.13-90 85h-30c0-63.41 53.83-115 120-115s120 51.59 120 115z' />
  </IconBase>
));

Construction.displayName = 'Construction';

export default Construction;
